export default "__VITE_ASSET__55339924__"